<template>
	<div class="stickers-add">
		<StickerForm/>
	</div>
</template>

<script>
import StickerForm from '@/components/stickers/StickerForm'
import * as stickerModule from '@/store/sticker'

export default {
	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['sticker/']) {
			this.$store.registerModule('sticker', stickerModule.default)
		}
	},

	components: {
		StickerForm
	},

	computed: {
		stickerName () {
			return this.$route.params.name.split('-').join(' ')
		}
	}
}
</script>

<style lang="scss" scoped>
.stickers-add {
	width: 100%;
	height: 100%;
}
</style>
